import React, { createContext, useMemo } from 'react';
import { useContext } from '../utils/useContext';
import { createUseValidationHook } from '../utils/useValidation';
import { Context as SessionContext } from './Session';
export const Context = createContext(undefined);
const useValidation = createUseValidationHook();
export const RevalidateProvider = ({ onValidateSession, children, }) => {
    const context = useContext(SessionContext);
    const session = useMemo(() => {
        const { setSession, ...rest } = context;
        return rest;
    }, [context]);
    const isValidating = useValidation({
        onValidate: onValidateSession,
        value: session,
        setValue: context.setSession,
    });
    return React.createElement(Context.Provider, { value: isValidating }, children);
};
//# sourceMappingURL=Revalidate.js.map